<template>
    <div class="addCouponWrap fc ac">
        <div class="box fc ac">
            <div class="row fc">
                <span>请输入激活码</span>
                <div class="ipt_wrap fr ac jsb">
                    <input v-model="code" type="text" />
                    <!-- <img @click="scanCode" src="../../../static/imgs/movie/scan.png" alt=""> -->
                </div>
            </div>
            <div class="row fc">
                <span>手机号</span>
                <input class="phone_ipt" v-model="formatPhone" disabled type="text" />
            </div>
        </div>
        <button @click="bindCoupon" class="confirmBtn">确定</button>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
    data() {
        return {
            code: "", 
            phoneNo: this.getLocal("phoneNo") ? this.getLocal("phoneNo") : "",
            type: this.$route.query.type ? this.$route.query.type : ""
        };
    },
    components: {},
    computed: {
        formatPhone: function() {
            if(this.phoneNo){
                return this.phoneNo.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2");
            } else {
                return ""
            }
            
        }
    },
    created() {},
    methods: {
        bindCoupon() {
            if (!this.code) {
                Toast({
                    message: "请先输入激活码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return
            }
            this.$post({
                method: this.type == "card" ? "member.coupon.vipcard.bind" : "member.coupon.bind",
                auth_code: this.getLocal("auth_code"),
                cardpass: this.code,
                showtype: "Y"
            }).then(res => {
                if (res.success) {
                    this.$router.back(-1)
                    Toast({
                        message: "添加成功",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            });
        },
        // scanCode(){
        //     wx.scanQRCode({
        //         needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        //         scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        //         success: (res) => {
        //             console.log('res :', res);
        //         }
        //     });
        // }
    }
};
</script>
<style scoped lang="scss">
.addCouponWrap {
    .box {
        width: 690px;
        background: #fff;
        border-radius: 15px;
        box-shadow: 2px 4px 10px 0 #ababab;
        margin-top: 40px;
        font-size: 28px;
        .row {
            width: 100%;
            padding: 0 50px;
            box-sizing: border-box;
            border-bottom: 1px solid #eff1f2;
            span {
                height: 90px;
                line-height: 90px;
            }
            .phone_ipt {
                height: 80px;
                line-height: 80px;
                width: 100%;
                padding: 0 20px;
                box-sizing: border-box;
                background: #eff1f2;
                margin-bottom: 40px;
                border-radius: 10px;
            }
            .ipt_wrap {
                height: 80px;
                width: 100%;
                padding: 0 20px;
                box-sizing: border-box;
                background: #eff1f2;
                margin-bottom: 40px;
                border-radius: 10px;
                input {
                    height: 70px;
                    width: 85%;
                    line-height: 70px;
                    background: #eff1f2;
                }
                img {
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }
    .confirmBtn {
        width: 690px;
        height: 80px;
        border-radius: 10px;
        // border: 1px solid #e44c4a;
        color: #fff;
        font-size: 28px;
        background: #e44c4a;
        margin-top: 50px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/coupon/addCoupon.vue